import React from 'react'
import "./Making_payments.css"

function Making_payments() {
    return (
        <>
            <section className='Making_payments margin_section '>
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 col-sm-6">
                            <div className="content_holder">
                                <div>
                                    <h2>Making Payments</h2>
                                    <h2 className='green_text'>Simple, Timely & Stress-Free</h2>

                                    <p>We built this app with one simple goal to make rent and utility payments easy, reliable, and transparent for everyone. Whether it’s paying your monthly rent, uploading an electricity bill, or getting reminders before due dates our platform is designed to take the stress out of everyday payments.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 col-sm-5">
                            <div className="img_holder">
                                <img src="/assets/images/about/about-card/img_1.png" alt="mobile" className="mock_up" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Making_payments